// extracted by mini-css-extract-plugin
export default {"block":"ChooseBlock_block__rLcuf","text":"ChooseBlock_text__ETmWs"};